import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Icon } from '@appfolio/react-gears';

interface Props {
  isValid: boolean | null,
  value: string | null,
  requirement: string
}

const PasswordRequirement = (props: Props) => {
  const {
    isValid,
    value,
    requirement
  } = props;

  const [style, setStyle] = useState({
    icon: 'circle',
    iconClass: 'text-muted',
    iconStyle: { fontSize: '7px', paddingRight: '6px' },
    textClass: 'text-dark'
  });


  useEffect(() => {
    if (value !== null) {
      if (isValid) {
        setStyle({
          icon: 'check',
          iconClass: 'text-success',
          iconStyle: { fontSize: '10px', paddingRight: '4px' },
          textClass: 'text-muted'
        });
      } else {
        setStyle({
          icon: 'times',
          iconClass: 'text-danger',
          iconStyle: { fontSize: '10px', paddingRight: '7px' },
          textClass: 'text-danger'
        });
      }
    }
  }, [value, isValid]);

  return (
    <li>
      <Icon className={`modal-dialog-centered ${style.iconClass}`} name={style.icon} style={style.iconStyle} />
      <small className={`body-small align-middle ${style.textClass}`}>{requirement}</small>
    </li>
  );
};

export default observer(PasswordRequirement);
